import { useEffect, useState } from "react";
import ProductService from "../service/ProductService";
import { useLocation } from "react-router-dom";

const useProductTechnicalInfo = ({ productInfo, onError }) => {
  const [loading, setLoading] = useState(true);
  const [technicalInfo, setTechnicalInfo] = useState([]);
  const productService = new ProductService();
  const locationUrl = useLocation();

  const isFringeBenefitsPage = locationUrl?.pathname?.toLowerCase()?.includes("fringe");

  const loadTechnicalInfo = async () => {
    setLoading(true);

    if (!isFringeBenefitsPage) {
      const resTechInfo = await productService.getTechnicalInfo(productInfo.data.product.id);

      if (resTechInfo.messageCode !== 200001) {
        onError(resTechInfo.messageCode);
        if (resTechInfo.messageCode === 500000) console.log(resTechInfo);
      } else setTechnicalInfo(resTechInfo.result);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (productInfo) loadTechnicalInfo(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productInfo]);

  return { loading, technicalInfo };
};

export default useProductTechnicalInfo;
